import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from "../shared/shared.module";
import { LoginComponent } from './login/login.component';
import { SettingsComponent } from './settings/settings.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { ChangePasswordComponent } from './changepassword/changepassword.component';
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';

const accountRoutes: Routes = [{
    path: 'login',
    component: LoginComponent,
}, {
    path: 'settings',
    component: SettingsComponent,
}, {
    path: 'signup',
    component: SignupComponent,
},{
    path: 'forgotpassword',
    component: ForgotPasswordComponent,
},{
    path: 'changepassword',
    component: ChangePasswordComponent,
},{
    path: 'resetpassword',
    component: ResetPasswordComponent,
}];

@NgModule({
    imports: [
        FormsModule,
        BrowserModule,
        SharedModule,
        RouterModule.forChild(accountRoutes),
    ],
    declarations: [
        LoginComponent,
        SignupComponent,
        SettingsComponent,
        ForgotPasswordComponent,
        ChangePasswordComponent,
        ResetPasswordComponent
    ],
})
export class AccountModule {}
